var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRangeTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 9.375C20.9105 9.375 21.75 8.53553 21.75 7.5C21.75 6.46447 20.9105 5.625 19.875 5.625C18.8395 5.625 18 6.46447 18 7.5C18 8.53553 18.8395 9.375 19.875 9.375Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.7812V4.5C8.25 3.70435 8.56607 2.94129 9.12868 2.37868C9.69129 1.81607 10.4544 1.5 11.25 1.5C12.0456 1.5 12.8087 1.81607 13.3713 2.37868C13.9339 2.94129 14.25 3.70435 14.25 4.5V13.7812C15.0501 14.4059 15.6353 15.2648 15.9239 16.2381C16.2124 17.2113 16.19 18.2503 15.8597 19.2102C15.5294 20.1701 14.9076 21.0029 14.0813 21.5924C13.2549 22.182 12.2651 22.4989 11.25 22.4989C10.2349 22.4989 9.24509 22.182 8.41872 21.5924C7.59236 21.0029 6.97064 20.1701 6.64032 19.2102C6.31 18.2503 6.28755 17.2113 6.57612 16.2381C6.86468 15.2648 7.44986 14.4059 8.25 13.7812V13.7812Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.5C12.2855 19.5 13.125 18.6605 13.125 17.625C13.125 16.5895 12.2855 15.75 11.25 15.75C10.2145 15.75 9.375 16.5895 9.375 17.625C9.375 18.6605 10.2145 19.5 11.25 19.5Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.75V8.25",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangeTemperatureIcon);
export default __webpack_public_path__ + "static/media/RangeTemperatureIcon.e043003e9d26c687cb9d889fa0e3cd80.svg";
export { ForwardRef as ReactComponent };